import { Form, Formik } from 'formik'
import Button from '../../../../../components/buttons/buttons.component'
import React, { Component } from 'react'
import { CheckboxToggleInput } from '../../../../../components/form-components/inputs.component'
import { PRIMARY_COLOR } from '../../../../../styles/colors.style'
import { UpdateClientService } from '../services/update-client.service'
import { toastActions } from '../../../../../actions/toast.actions'
import { Creators as SiteCreators } from '../../../../../ducks/site/site'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'

class MuvicardFormComponent extends Component {
	constructor(props) {
		super(props)
		this.termsAndConditionsRef = React.createRef()
	}

	handleInactiveOneBuy = () => {
		const { toastSuccess, toastError, showLoading, hideLoading } = this.props
		showLoading()
		UpdateClientService.updateOneClickBuy().then((data) => {
			if (data.success) {
				toastSuccess({ message: 'Muvicard 1 Clique desativado' })
				this.refs.form.setFieldValue('oneclickbuy', false)
			} else {
				toastError({ message: 'Erro ao desativar Muvicard 1 Clique' })
			}
			hideLoading()
		})
	}
	render() {
		return (
			<Formik
				initialValues={this.initialValues}
				ref={'form'}
				render={(props) => (
					<Form noValidate>
						<div>
							<p>Muvicard 1 clique</p>
							<div
								style={{
									display: 'flex',
								}}>
								<CheckboxToggleInput
									id="oneclickbuy"
									disabled={true}
									{...props}
								/>
								<p style={{ paddingLeft: '1rem' }}>
									{props.values.oneclickbuy ? (
										<span
											style={{
												color: PRIMARY_COLOR,
											}}>
											Sim
										</span>
									) : (
										'Não'
									)}
								</p>
								{props.values.oneclickbuy && (
									<Button
										primary
										id="btnMuvicardOnClick"
										style={{ marginLeft: 'auto' }}
										type="button"
										onClick={this.handleInactiveOneBuy}>
										Desativar compra com um click
									</Button>
								)}
							</div>
						</div>
					</Form>
				)}
			/>
		)
	}
}

const mapStateToProps = ({}) => ({})

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			toastError: toastActions.danger,
			toastSuccess: toastActions.success,
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading,
		},
		dispatch
	)

const MuvicardForm = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(MuvicardFormComponent)
)
export default MuvicardForm
